import { useState } from "react";
import { DropdownItem, DropdownMenu, Icon } from "semantic-ui-react";

import { Dropdown } from "components";
import "modules/Dayplanner/components/AppointmentBrandsFilter/AppointmentBrandsFilter.scss";

import type { BrandOption } from "modules/Dayplanner";

type AppointmentBrandsFilterProps = {
  brandsFilter: string[];
  brandOptions: BrandOption[];
  setSelectedBrand: (value: string) => void;
};

export const AppointmentBrandsFilter = ({ brandsFilter, brandOptions, setSelectedBrand }: AppointmentBrandsFilterProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const toggleFilterDropdown = () => {
    setOpen(prev => !prev);
  };

  const isSelectedOption = (option: BrandOption) => {
    return (brandsFilter.length === 0 && option.key === "all") || brandsFilter.includes(option.value);
  };

  const sortBrandOptions = [...brandOptions].sort((a, b) => {
    if (a.value === "all") return -1;
    if (b.value === "all") return 1;

    return Number(brandsFilter.includes(b.value)) - Number(brandsFilter.includes(a.value));
  });

  return (
    <div className="Dayplanner-AppointmentBrandsFilter" onClick={toggleFilterDropdown}>
      <Dropdown
        multiple={true}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        trigger={
          <div className="Dayplanner-AppointmentBrandsFilter-Dropdown">
            <div className="composite-icons">
              <Icon className="solid car" />
              <Icon className="tag" />
            </div>
            <div className="filter-length">{brandsFilter.length}</div>
          </div>
        }
      >
        <DropdownMenu>
          {sortBrandOptions.map((option: BrandOption, index: number) => {
            return (
              <DropdownItem
                selected={isSelectedOption(option)}
                key={`appointment-brands-filter-${index}`}
                onClick={() => {
                  setOpen(false);
                  setSelectedBrand(option.key);
                }}
              >
                <div className="Dayplanner-AppointmentBrandsFilter-Dropdown-Selection">
                  <p className="text">{option.text}</p>
                </div>
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
